"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.UrlDefinition = (0, services_definitions_1.defineService)('viewer-core/viewer-service-url');
//# sourceMappingURL=index.js.map